import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  id: "title",
  class: "py-12 bg-indigo-100 flex justify-center lg:justify-start lg:px-12"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer flex items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-2xl text-indigo-800 tracking-wide ml-2 font-semibold" }, " Allergies Manegement Application ")
  ])
], -1)
const _hoisted_2 = {
  id: "form",
  class: "mt-10 px-12 sm:px-24 md:px-48 lg:px-12 lg:mt-16 xl:px-24 xl:max-w-2xl"
}
const _hoisted_3 = { class: "text-center text-2xl text-indigo-900 font-display font-semibold lg:text-left xl:text-4xl xl:text-bold mb-5" }
const _hoisted_4 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold text-gray-700 tracking-wide mb-4" }, " Name ", -1)
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold text-gray-700 tracking-wide mb-4" }, " Email Address ", -1)
const _hoisted_8 = { class: "mb-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold text-gray-700 tracking-wide mb-4" }, " Password ")
], -1)
const _hoisted_10 = {
  key: 1,
  class: "mt-10"
}
const _hoisted_11 = {
  key: 2,
  class: "mt-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Extra = _resolveComponent("Extra")!

  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.isLogin ? "Login" : "Sign up"), 1),
      _createElementVNode("div", null, [
        _createElementVNode("form", null, [
          (!_ctx.isLogin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                  name: "name",
                  type: "text",
                  class: "w-full text-lg py-2 border-b border-gray-300 focus:outline-none focus:border-indigo-500",
                  placeholder: "Arpit"
                }, null, 512), [
                  [_vModelText, _ctx.name]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
              name: "email",
              type: "text",
              class: "w-full text-lg py-2 border-b border-gray-300 focus:outline-none focus:border-indigo-500",
              placeholder: "arpit@gmail.com"
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
              type: "password",
              name: "password",
              class: "w-full text-lg py-2 border-b border-gray-300 focus:outline-none focus:border-indigo-500",
              placeholder: "Enter your password"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ]),
          (_ctx.isLogin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (!_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      onSubmit: _ctx.onSubmit,
                      text: "Login"
                    }, null, 8, ["onSubmit"]))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      text: "Logging in..."
                    }))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (!_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      onSubmit: _ctx.onSubmit,
                      text: "Sign Up"
                    }, null, 8, ["onSubmit"]))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      text: "Signing up..."
                    }))
              ]))
        ]),
        (_ctx.isLogin)
          ? (_openBlock(), _createBlock(_component_Extra, {
              key: 0,
              textOne: "Dont have an account?",
              textTwo: "Sign Up",
              path: "/signup"
            }))
          : (_openBlock(), _createBlock(_component_Extra, {
              key: 1,
              textOne: "Already have an account?",
              textTwo: "Login",
              path: "/"
            }))
      ])
    ])
  ]))
}